import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["paymentOptions", "offerPrice"];

var _templateObject;

import React from "react";
import { Flex, IconAfterPay, IconPayPalBNPL, IconZipPay } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";
import { PayPalSDKProvider } from "../../../contexts/PayPalSDKContext/PayPalSDKContext.jsx";
import { BNPLPaymentMethod } from "../../pure/BNPLPaymentMethod/BNPLPaymentMethod.jsx";
import { PayPalBNPLLearnMoreButton } from "../../pure/paypal/PayPalBNPLLearnMoreButton/PayPalBNPLLearnMoreButton.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
var BNPLPaymentMethodsZone = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & > * {\n    flex: 1 1 0;\n    width: 0px;\n    padding-left: ", ";\n    padding-right: 0px;\n    border-right: 1px solid ", ";\n\n    &:first-of-type {\n      padding-left: 0px;\n      padding-right: ", ";\n    }\n\n    &:last-of-type {\n      border-right: none;\n    }\n  }\n"])), themeGet("space.4"), themeGet("colors.ui.borderColor"), themeGet("space.4"));
export var BNPLPaymentMethodsContainer = function BNPLPaymentMethodsContainer(_ref) {
  var paymentOptions = _ref.paymentOptions,
      offerPrice = _ref.offerPrice,
      containerProps = _objectWithoutProperties(_ref, _excluded);

  var mappedOptions = paymentOptions.map(function (paymentOption) {
    var formattedLabel = BNPLPaymentMethod.formatPaymentMethodLabel(paymentOption.label);

    switch (paymentOption.type) {
      case "AFTERPAY":
        return ___EmotionJSX(BNPLPaymentMethod, {
          key: paymentOption.type,
          role: "listitem",
          "aria-label": "Afterpay - ".concat(paymentOption.label),
          icon: ___EmotionJSX(IconAfterPay, {
            width: "80px"
          })
        }, formattedLabel);

      case "ZIPPAY":
        return ___EmotionJSX(BNPLPaymentMethod, {
          key: paymentOption.type,
          role: "listitem",
          "aria-label": "ZipPay - ".concat(paymentOption.label),
          icon: ___EmotionJSX(IconZipPay, {
            width: "50px"
          })
        }, formattedLabel);

      case "PAYPAL":
        return ___EmotionJSX(PayPalSDKProvider, {
          key: paymentOption.type
        }, ___EmotionJSX(BNPLPaymentMethod, {
          role: "listitem",
          "aria-label": "PayPal Pay in 4 - ".concat(paymentOption.label),
          icon: ___EmotionJSX(IconPayPalBNPL, {
            width: "95px",
            height: "15px"
          })
        }, ___EmotionJSX(PayPalBNPLLearnMoreButton, {
          amount: offerPrice,
          textDecoration: "underline",
          color: "textTertiary"
        }, formattedLabel)));
    }
  }).filter(Boolean);
  if (mappedOptions.length === 0) return null;
  return ___EmotionJSX(BNPLPaymentMethodsZone, _extends({
    role: "list"
  }, containerProps), mappedOptions.map(function (option) {
    return ___EmotionJSX(React.Fragment, {
      key: option === null || option === void 0 ? void 0 : option.key
    }, option);
  }));
};